import { render, staticRenderFns } from "./About-desc.vue?vue&type=template&id=2fed4f14&scoped=true&"
import script from "./About-desc.vue?vue&type=script&lang=js&"
export * from "./About-desc.vue?vue&type=script&lang=js&"
import style0 from "./About-desc.vue?vue&type=style&index=0&id=2fed4f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed4f14",
  null
  
)

export default component.exports